var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleIcon5OfNewBill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4047_29234)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75C0 1.50736 1.00736 0.5 2.25 0.5H7.6287C8.2254 0.5 8.79773 0.737053 9.21968 1.15901L11.341 3.28033C11.7629 3.70229 12 4.27459 12 4.87132V13.25C12 14.4927 10.9927 15.5 9.75 15.5H2.25C1.00736 15.5 0 14.4927 0 13.25V2.75ZM2.25 2C1.83579 2 1.5 2.33579 1.5 2.75V13.25C1.5 13.6642 1.83579 14 2.25 14H9.75C10.1642 14 10.5 13.6642 10.5 13.25V4.87132C10.5 4.67241 10.4209 4.48164 10.2803 4.34099L8.15903 2.21967C8.01833 2.07902 7.8276 2 7.6287 2H2.25Z",
    fill: "#7D44A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17106 8.49609C3.9541 8.27913 3.60234 8.27913 3.38538 8.49609C3.16842 8.71305 3.16842 9.06482 3.38538 9.28176L4.10366 10L3.38538 10.7183C3.16842 10.9352 3.16842 11.287 3.38538 11.5039C3.60234 11.7209 3.9541 11.7209 4.17106 11.5039L5.28216 10.3928C5.49911 10.1759 5.49911 9.82415 5.28216 9.60721L4.17106 8.49609ZM6.556 10.5556C6.24916 10.5556 6.00044 10.8043 6.00044 11.1111C6.00044 11.4179 6.24916 11.6667 6.556 11.6667H8.22266C8.5295 11.6667 8.77822 11.4179 8.77822 11.1111C8.77822 10.8043 8.5295 10.5556 8.22266 10.5556H6.556Z",
    fill: "#7D44A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4047_29234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleIcon5OfNewBill);
export default __webpack_public_path__ + "static/media/littleIcon5OfNewBill.3584d0c447524b2d4d62a9cdd959645a.svg";
export { ForwardRef as ReactComponent };